import { useState } from "react";

const UseForm = (initialFieldValues) => {
    const [values, setValues] = useState(initialFieldValues)
    const [errors, setErrors] = useState({})

    const handleInputChange = e => {
        const { name, value } = e.target
        const fieldValue = { [name]: value }
        setValues({
            ...values,
            ...fieldValue
        })
    }

    const handleInpuFileChange = e => {
        const { name } = e.target
        const fieldValue = { [name]: e.target.files }
        setValues({
            ...values,
            ...fieldValue
        })
    }

    const handleSearchBoxChange = (option, name) => {
        if(!option){
            resetForm()
            return
        }
        const fieldValue = { [name]: option.id }
        setValues({
            ...values,
            ...fieldValue
        })
    }

    const handleInputDateChange = (date, field) => {
        const fieldValue = { [field]: date.format("YYYY/MM/DD") }
        setValues({
            ...values,
            ...fieldValue
        })
    }

    const handleSearchMultipleBoxChange = (option, name) => {
        const fieldValue = { [name]: option }
        setValues({
            ...values,
            ...fieldValue
        })
    }

    const resetForm = () => {
        setValues({
            ...initialFieldValues
        })
        setErrors({})
    }

    const addValue = fieldValue => {
        setValues({
            ...fieldValue 
        })
    }

    return {
        values,
        setValues,
        errors,
        setErrors,
        handleInputChange,
        handleInpuFileChange,
        handleSearchBoxChange,
        handleInputDateChange,
        handleSearchMultipleBoxChange,
        addValue,
        resetForm
    }
}

export default UseForm;